module.exports = __webpack_public_path__ + "img/TK.625356b3.png";